var $ = require('jquery');
var ScrollMagic = require('scrollmagic');

var utils = {
  'defaults': {
    'triggerElement': null,
    'reverse': false,
    'triggerHook': 0.9
  },
  init: function(triggerElement, options) {
    var fadeConfig = {}, fadeWrappers = [];
    var controller = new ScrollMagic.Controller();
    
    $.extend(fadeConfig, this.defaults, options);
    
    var fadeWrappers = document.querySelectorAll(triggerElement);
    
    for( var i=0; i < fadeWrappers.length; i++){
      var element = fadeWrappers[i];
	  fadeConfig.triggerElement = element;
      new ScrollMagic.Scene(fadeConfig).setClassToggle(element,'fade-in').addTo(controller);
    }
  }
};

module.exports = utils;
